module.exports = __webpack_public_path__ + "56446ccd82d9030ff39d52626d4aa9af.svg";